import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import sq from './locales/sq.json';
import sr from './locales/sr.json';

// To add a language: create locales/<code>.json with the same keys, add it here and to LANGUAGES.
export const LANGUAGES = [
    { code: 'en', label: 'English', short: 'EN', intl: 'en-GB' },
    { code: 'sq', label: 'Shqip', short: 'SQ', intl: 'sq-AL' },
    { code: 'sr', label: 'Crnogorski', short: 'CG', intl: 'sr-Latn-ME' },
];
const SUPPORTED = LANGUAGES.map(l => l.code);
const STORAGE_KEY = 'SD_LANG';

export const normalizeLang = (code) => {
    const base = String(code || '').toLowerCase().split(/[-_]/)[0];
    return SUPPORTED.includes(base) ? base : null;
};

const detect = () => {
    try {
        const saved = normalizeLang(localStorage.getItem(STORAGE_KEY));
        if (saved) return saved;
    } catch { /* storage unavailable */ }
    for (const l of navigator.languages || [navigator.language]) {
        const n = normalizeLang(l);
        if (n) return n;
    }
    return 'en';
};

/** BCP-47 locale for Intl date/number formatting of the active language. */
export const intlLocale = () => (LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0]).intl;

i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, sq: { translation: sq }, sr: { translation: sr } },
    lng: detect(),
    fallbackLng: 'en',
    supportedLngs: SUPPORTED,
    interpolation: { escapeValue: false },
});

const applyDocumentLang = (lng) => {
    document.documentElement.lang = lng;
    try { localStorage.setItem(STORAGE_KEY, lng); } catch { /* ignore */ }
};
applyDocumentLang(i18n.language);
i18n.on('languageChanged', applyDocumentLang);

export default i18n;
